import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      nav(loc.state?.from || "/conta");
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-20" data-testid="page-login">
      <p className="label-sm mb-3 text-center">Conta</p>
      <h1 className="font-serif text-4xl text-center brand-text mb-10">Entrar</h1>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="label-sm">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-line mt-2" data-testid="login-email" />
        </div>
        <div>
          <label className="label-sm">Palavra-passe</label>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-line mt-2" data-testid="login-password" />
        </div>
        {err && <p className="text-sm" style={{ color: "#9E4747" }} data-testid="login-error">{err}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="btn-login">
          {loading ? "A entrar..." : "Entrar"}
        </button>
      </form>
      <p className="text-sm text-center brand-muted mt-8">
        Ainda não tem conta? <Link to="/registar" className="brand-primary-text underline">Criar conta</Link>
      </p>
    </main>
  );
}
